<template>
  <div>
    <fieldset>
      <label class="input-container" title="only-multiword">
        <div>Only multiword terms</div>
        <input
          type="checkbox"
          name="only-multiword"
          :checked="settings.onlyMultiword"
          @click="onOnlyMultiword($event)"
        />
        <span class="check-checkmark"></span>
      </label>
      <label class="input-container" title="only-eg">
        <div>Only 'ég ...'</div>
        <input
          type="checkbox"
          name="only-eg"
          :checked="settings.onlyEg"
          @click="onOnlyEg($event)"
        />
        <span class="check-checkmark"></span>
      </label>
      <div class="input-container">
        <div @click="onResetCategories()">Use all categories</div>
      </div>
    </fieldset>
    <fieldset>
      <label class="input-container" title="FR to many IS">
        <div>FR to many IS</div>
        <input
          type="checkbox"
          name="game-fr-toNis"
          :checked="settings.game['fr-to-Nis']"
          :disabled="settings.game['fr-to-Nis'] && checkedGamesCount == 1"
          @click="onGame($event, 'fr-to-Nis')"
        />
        <span class="check-checkmark"></span>
      </label>
      <label class="input-container" title="IS to many FR">
        <div>IS to many FR</div>
        <input
          type="checkbox"
          name="game-is-toNfr"
          :checked="settings.game['is-to-Nfr']"
          :disabled="settings.game['is-to-Nfr'] && checkedGamesCount == 1"
          @click="onGame($event, 'is-to-Nfr')"
        />
        <span class="check-checkmark"></span>
      </label>
      <label class="input-container" title="IS to FR">
        <div>IS to FR</div>
        <input
          type="checkbox"
          name="game-is-to-fr"
          :checked="settings.game['is-to-fr']"
          :disabled="settings.game['is-to-fr'] && checkedGamesCount == 1"
          @click="onGame($event, 'is-to-fr')"
        />
        <span class="check-checkmark"></span>
      </label>
      <label class="input-container" title="FR to IS">
        <div>FR to IS</div>
        <input
          type="checkbox"
          name="game-fr-to-is"
          :checked="settings.game['fr-to-is']"
          :disabled="settings.game['fr-to-is'] && checkedGamesCount == 1"
          @click="onGame($event, 'fr-to-is')"
        />
        <span class="check-checkmark"></span>
      </label>
      <label class="input-container" title="Path">
        <div>Path</div>
        <input
          type="checkbox"
          name="game-path"
          :checked="settings.game['path']"
          :disabled="settings.game['path'] && checkedGamesCount == 1"
          @click="onGame($event, 'path')"
        />
        <span class="check-checkmark"></span>
      </label>
      <label class="input-container" title="Spell">
        <div>Spell</div>
        <input
          type="checkbox"
          name="game-spell"
          :checked="settings.game['spell']"
          :disabled="settings.game['spell'] && checkedGamesCount == 1"
          @click="onGame($event, 'spell')"
        />
        <span class="check-checkmark"></span>
      </label>
      <label class="input-container" title="Syllables">
        <div>Syllables</div>
        <input
          type="checkbox"
          name="game-syllables"
          :checked="settings.game['syllables']"
          :disabled="settings.game['syllables'] && checkedGamesCount == 1"
          @click="onGame($event, 'syllables')"
        />
        <span class="check-checkmark"></span>
      </label>
      <label class="input-container" title="Hole">
        <div>Hole</div>
        <input
          type="checkbox"
          name="game-hole"
          :checked="settings.game['hole']"
          :disabled="settings.game['hole'] && checkedGamesCount == 1"
          @click="onGame($event, 'hole')"
        />
        <span class="check-checkmark"></span>
      </label>
      <div class="input-container">
        <div @click="onResetGames()">Play all games</div>
      </div>
    </fieldset>
    <fieldset>
      <label>Durée de la session (minutes)</label>
      <VueSlideBar
        class="duration-slider"
        v-model="settings.duration"
        :min="1"
        :max="60"
        @dragEnd="onDurationChange"
      >
      </VueSlideBar>
      <input
        size="4"
        type="number"
        min="1"
        max="60"
        v-model="settings.duration"
      /><button :disabled="settings.duration < 1 || settings.duration > 60" @click="onDurationChange">
        Apply
      </button>
    </fieldset>
  </div>
</template>

<script>
const gameSettings = require("@/gameSettings.js");
import VueSlideBar from "vue-slide-bar";

export default {
  name: "Preferences",
  components: { VueSlideBar },
  data() {
    return {
      settings: gameSettings.get(),
    };
  },
  computed: {
    checkedGamesCount() {
      let count = 0;
      for (let name in this.settings.game) {
        if (this.settings.game[name]) count++;
      }
      return count;
    },
  },
  methods: {
    onOnlyMultiword(e) {
      this.settings.onlyMultiword = !this.settings.onlyMultiword;
      console.log("New setting onlyMultiword: " + this.settings.onlyMultiword);
      gameSettings.set(this.settings);

      this.$store.dispatch("init");
    },
    onOnlyEg(e) {
      this.settings.onlyEg = !this.settings.onlyEg;
      console.log("New setting onlyEg: " + this.settings.onlyEg);
      gameSettings.set(this.settings);

      this.$store.dispatch("init");
    },
    onResetCategories() {
      this.$store.dispatch("categorySelected", undefined);
    },
    onGame(e, name) {
      this.settings.game[name] = !this.settings.game[name];
      console.log(
        "New setting onGame: " + name + " => " + this.settings.game[name]
      );
      gameSettings.set(this.settings);

      this.$store.dispatch("init");
    },
    onResetGames() {
      // TODO
    },
    onDurationChange() {
      console.log("New duration: " + this.settings.duration);
      gameSettings.set(this.settings);

      this.$store.dispatch("init");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/scss/components-shared.scss";
@import "../scss/shared-radio-check.scss";

.text-container {
  padding-left: 35px;
}
</style>
